//
//
//
//
//
//
//
//

export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    isVisible: {
      type: Boolean,
      default: true,
    },
  },
}
